import { Bookmark as Bookmark_kojaro } from './Bookmark.kojaro';
import { Bookmark as Bookmark_phosphor } from './Bookmark.phosphor';
import { Bookmark as Bookmark_zoomg } from './Bookmark.zoomg';
import { Bookmark as Bookmark_zoomit } from './Bookmark.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Bookmark_kojaro;

    case 'zoomg':
      return Bookmark_zoomg;

    case 'phosphor':
      return Bookmark_phosphor;

    default:
      return Bookmark_zoomit;
  }
};

export const Bookmark = IconRenderer();
